import { createFileRoute, Link } from "@tanstack/react-router"

export const Route = createFileRoute("/_admin/admin/")({
  component: AdminIndexPage,
})

function AdminIndexPage() {
  return (
    <div className="flex flex-col gap-2">
      <Link className="wb-link" to="/admin/create-user">
        Create User
      </Link>
    </div>
  )
}
